import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { TranslateService } from '@ngx-translate/core';

import { NotificationFacade } from '@ridango/components';
import { RecoverPasswordFacade } from '@ridango/components/lib/auth/+state/recover-password';

import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'rwidget-recover-password',
    templateUrl: 'recover-password.component.html'
})
export class RecoverPasswordComponent implements OnInit, OnDestroy {
    private componentDestroyed$ = new Subject<void>();

    loading$: Observable<boolean> = this.recoverPassword.loading$;

    locale: string;
    email: string;
    emailForm: FormGroup;

    @Input() showRequiredText = true;
    @Input() callback: string = null;

    @Output() onCompleteStep = new EventEmitter<number>();
    @Output() onSubmitEmail = new EventEmitter<any>();

    constructor(
        private recoverPassword: RecoverPasswordFacade,
        private notification: NotificationFacade,
        private translate: TranslateService
    ) {
        this.recoverPassword.resetStep();

        this.recoverPassword.error$
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((error) => error && this.handleError(error));

        this.recoverPassword.step$
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((step) => this.onCompleteStep.emit(step));

        this.emailForm = new FormGroup({
            email: new FormControl('', { validators: [Validators.required, Validators.email], updateOn: 'change' })
        });
    }

    ngOnInit() {
        this.locale = this.translate.currentLang;
    }

    submit() {
        this.notification.removeAll();
        const emailControl = this.emailForm.controls.email;
        if (this.emailForm.invalid) {
            emailControl.markAsTouched();
            return;
        }
        this.email = emailControl.value.trim();
        this.recoverPassword.submitEmail(this.email, this.locale, this.callback);
        this.onSubmitEmail.emit(this.email);
    }

    handleError(e: any) {
        const errorMessage = e.error ? e.error.error : 'INVALID_INPUT';
        this.notification.error(this.translate.instant(errorMessage));
    }

    ngOnDestroy(): void {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
}
